import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getUsersRights() {
    return () => {
        return apiCaller
            .call(api.getUsersRights())
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getUsersRights - ', e);
                throw e;
            });
    };
}
function editUser(user) {
    return () => {
        return apiCaller
            .call(api.editUser(user))
            .then(result => {
                return result.data.User;
            })
            .catch(e => {
                Logger.log('dataActions: editUserRight - ', e);
                throw e;
            });
    };
}
function addUser(user) {
    return () => {
        return apiCaller
            .call(api.addUser(user))
            .then(result => {
                return result.data.User;
            })
            .catch(e => {
                Logger.log('dataActions: addUserRight - ', e);
                throw e;
            });
    };
}

export { getUsersRights, editUser, addUser };



// WEBPACK FOOTER //
// ./scenes/UsersRights/actions.js